import VForm from '@/vuetify_custom/v-form'
import VModel from '@/vuetify_custom/v-modal_v1'
import {postPlacingAdsRecordDeleteApi} from '../service'
export default {
    data() {
        return {
            dis: false,
            submitLoading: false,
            params:{
                id: null,
                del_reason:null,
            },
            // content_types: [],
            platform: []
        }
    },
    computed: {
        baseInforFields() {
            const d = [(val) => !!val || '必填']
            const arr = [
                {
                    label: '理由',
                    key:'del_reason',
                    cols: 12,
                    type: 'textareas_field',
                    rows: 4,
                    // required: true,
                    rules:d
                },
             
            ]
            return arr
        },
    },

    methods: {

        edit(params) {
            this.dis = true
            
            this.params.del_reason = ''
            this.params.id = params.id
        },
        submit() {
            if (!(this.$refs.base && this.$refs.base.validate && this.$refs.base.validate())) {
                return
            }
            this.submitLoading = true
            const params = {...this.params}
            // params.tags = this.params.tags.join(',')
            postPlacingAdsRecordDeleteApi(params).then(() => {
                this.$emit('success')
                this.dis = false
                this.$Message.success('废弃成功！')
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        title="废弃"
        max-width="600"
        loading={this.submitLoading}
        on={{
             ok: this.submit,
            // cancel: _this.cancel
        }}
       
    >
        <VForm
            ref="base"
            v-model={this.params}
            fields={this.baseInforFields}
        />
        </VModel>
    }
}